import { memo, useState } from "react";
import { useI18n } from "@/i18n";
import { AVAILABLE_TIMEZONES, getTimezone, setTimezone } from "@/utils/formatDate";
import { typography, transitions } from "@/design-system/tokens";

export const TimezoneSelector = memo(function TimezoneSelector() {
  const { t } = useI18n();
  const [current, setCurrent] = useState(getTimezone);

  const handleChange = (tz: string) => {
    setTimezone(tz);
    setCurrent(tz);
    window.location.reload();
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
      <span style={{ fontFamily: typography.fontFamily, fontSize: "11px", color: "#999", whiteSpace: "nowrap" }}>
        {t.platform.selectTimezone}:
      </span>
      <select
        value={current}
        onChange={e => handleChange(e.target.value)}
        style={{
          fontFamily: typography.fontFamily,
          fontSize: "12px",
          fontWeight: typography.weight.medium,
          color: "#555",
          background: "#fff",
          border: "1px solid #e8e8e8",
          borderRadius: "8px",
          padding: "6px 12px",
          cursor: "pointer",
          outline: "none",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          transition: `border-color ${transitions.fast}`,
        }}
      >
        {AVAILABLE_TIMEZONES.map(tz => (
          <option key={tz.value} value={tz.value}>{tz.label}</option>
        ))}
      </select>
    </div>
  );
});
